import { Component, OnInit } from '@angular/core';
import { MainComponent } from 'app/main/main.component';

@Component({
  selector: 'app-come-lavoriamo',
  templateUrl: './come-lavoriamo.component.html',
  styleUrls: ['./come-lavoriamo.component.css']
})
export class ComeLavoriamoComponent implements OnInit {

  constructor(private main: MainComponent,) { }

  ngOnInit(): void {
    this.main.heading = 'Come lavoriamo'
    this.main.imgSrc = 'assets/img/index-banner.jpg';
  }

}
